import { gql } from "@apollo/client";

export const UPLOADCOSTAR_CSV = gql`
mutation UploadCsv($fileName: String!, $encryption: String!, $testEnv: Boolean) {
    uploadCsv(fileName: $fileName, encryption: $encryption, testEnv: $testEnv) {
      success
      message
    }
  }
`